import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M4.65 4.762c0-1.588 1.718-2.559 3.09-1.8l12.544 6.937.13.078a2.052 2.052 0 0 1 0 3.445l-.13.077L7.74 20.436c-1.37.76-3.089-.212-3.089-1.8zm1.5 13.875c0 .413.465.707.863.487l12.546-6.938.068-.044a.55.55 0 0 0 0-.885l-.068-.044L7.014 4.274c-.4-.22-.864.074-.864.488z"
    }, null, -1)
  ]))]))
}
export default { render: render }